import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

const ProjectModulesSkeleton: React.FC = () => (
  <Paper sx={{ mt: 2 }}>
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={tableHeaderStyles}>Project Name</TableCell>
            <TableCell sx={tableHeaderStyles}>Status</TableCell>
            <TableCell sx={tableHeaderStyles}>Project Manager</TableCell>
            <TableCell sx={tableHeaderStyles}>Client</TableCell>
            <TableCell sx={tableHeaderStyles}>Start Date</TableCell>
            <TableCell sx={tableHeaderStyles}>End Date</TableCell>
            <TableCell sx={tableHeaderStyles}>Created By</TableCell>
            <TableCell sx={tableHeaderStyles} align="center">
              Actions
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(6)].map((_, index) => (
            <TableRow key={index} hover>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={160} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={80} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={120} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={140} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={90} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={90} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles}>
                <Skeleton variant="text" width={130} height={20} />
              </TableCell>
              <TableCell sx={tableCellStyles} align="center">
                <Skeleton variant="circular" width={24} height={24} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
);

export default ProjectModulesSkeleton; 